export const resolveObbStationCoords = (station: any): { lat: number; lng: number } | null => {
  const lat = typeof station?.latitude === "number" ? station.latitude : station?.location?.lat;
  const lng = typeof station?.longitude === "number" ? station.longitude : station?.location?.lon;

  if (typeof lat !== "number" || typeof lng !== "number") {
    return null;
  }

  return { lat, lng };
};
